import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { LoginGuard } from '../../../guard/loginguard.guard';
import { FengGuard } from '../../../guard/fengguard.guard';
import { EnableFacialRecognitionGuard } from 'src/app/guard/enable-facial-recognition.guard';
import { EnableSolutionsLinkGuard } from 'src/app/guard/enable-solutions-link.guard';
import { DebugComponent } from 'src/app/debug/debug.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'consulta-maple-bear',
        loadChildren: () => import('../../pages/consulta-maple-bear/consulta-maple-bear.module').then(m => m.ConsultaMapleBearModule),
      },
      {
        path: 'debug',
       component: DebugComponent
      },
      {
        path: 'payment-method',
        loadChildren: () => import('../../pages/payment-method/payment-method.module').then(m => m.PaymentMethodModule),
      },
      {
        path: 'payment-method/:eventId',
        loadChildren: () => import('../../pages/payment-method/payment-method.module').then(m => m.PaymentMethodModule),
      },
      {
        path: 'my-profile',
        loadChildren: () => import('../../pages/my-account/my-profile/my-profile.module').then(m => m.MyProfileModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'my-orders',
        loadChildren: () => import('../../pages/my-account/my-orders/my-orders.module').then(m => m.MyOrdersModule),
      },
      {
        path: 'my-sells',
        loadChildren: () => import('../../pages/my-account/my-sells/my-sells.module').then(m => m.MySellsModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'reconhecimento-facial',
        loadChildren: () => import('../../pages/my-account/facial-rekognition/facial-rekognition.module').then(m => m.FacialRekognitionModule),
        canActivate: [LoginGuard, EnableFacialRecognitionGuard]
      },
      {
        path: 'list-users',
        loadChildren: () => import('../../pages/my-account/list-users/list-users.module').then(m => m.ListUsersModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'recovery/:email/:token',
        loadChildren: () => import('../../pages/change-password/change-password.module').then(m => m.ChangePasswordModule),
        canActivate: [FengGuard]
      },
      {
        path: 'terms-of-use',
        loadChildren: () => import('../../pages/terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule),
        canActivate: [FengGuard]
      },
      {
        path: 'terms-of-use-porsche',
        loadChildren: () => import('../../pages/terms-of-use-porsche/terms-of-use-porsche.module').then(m => m.TermsOfUsePorscheModule),
        canActivate: [FengGuard]
      },
      {
        path: 'privacy-policy',
        loadChildren: () => import('../../pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
        canActivate: [FengGuard]
      },
      {
        path: 'about-us',
        loadChildren: () => import('../../pages/about-us/about-us.module').then(m => m.AboutUsModule),
        canActivate: [FengGuard]
      },
      {
        path: 'solucoes',
        loadChildren: () => import('../../pages/solutions/solutions.module').then(m => m.SolutionsModule),
        canActivate: [FengGuard, EnableSolutionsLinkGuard]
      },
      {
        path: 'half-price-policy',
        loadChildren: () => import('../../pages/half-price-policy/half-price-policy.module').then(m => m.HalfPricePolicyModule),
        canActivate: [FengGuard]
      },
      {
        path: 'maplebear',
        loadChildren: () => import('../../pages/maple-bear/maple-bear.module').then(m => m.MapleBearModule),
      },

      {
        path: 'event/:id',
        loadChildren: () => import('../../pages/event/event.module').then(m => m.EventModule),
      },

      {
        path: 'trocar-setor/:orderId',
        loadChildren: () => import('../../pages/change-order-ticket/change-order-ticket.module').then(m => m.ChangeOrderTicketModule),
        canActivate: [LoginGuard]
      },

      {
        path: 'transfer-ticket/:orderTicketId',
        loadChildren: () => import('../../pages/customer-self-transfer/customer-self-transfer.module').then(m => m.CustomerSelfTransferModule),
        canActivate: [LoginGuard]
      },
      {
        path: 'camarotestage',
        loadChildren: () => import('../../pages/camarote-stage/camarote-stage.module').then(m => m.CamaroteStageModule), 
      },
      {
        path: ':slug',
        loadChildren: () => import('../../pages/event/event.module').then(m => m.EventModule), 
      },
     
      {
        path: 'event-multi-step/:slug',
        loadChildren: () => import('../../pages/event-multi-step/event-multi-step.module').then(m => m.EventMultiStepModule), 
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
